module.exports = __webpack_public_path__ + "img/icon_map_dian_lixian1.3559ad1e.svg";